module.exports = __webpack_public_path__ + "img/placeholder-image.a36832a1.png";